'use client';

import {
    ExperimentVersion,
    ExperimentCookies,
} from '../types/experimentValues';
import { useCacheKey } from './useCacheKey';
import type { ExperimentVersionType } from '../types/experimentValues';

/**
 * For client component render.
 *
 * This function will return the experiment version.
 */
export function useExperimentValue(): ExperimentVersionType {
    const { cookies } = useCacheKey();
    const experimentValue = cookies.get(
        ExperimentCookies.EXPERIMENT_VERSION
    ) as ExperimentVersionType;

    return (
        Object.values(ExperimentVersion) as ExperimentVersionType[]
    ).includes(experimentValue)
        ? experimentValue
        : ExperimentVersion.SEARCH_BROWSE;
}
